import { render, staticRenderFns } from "./TheLoadingIndicator.vue?vue&type=template&id=0b1970b3&v-if=loading"
import script from "./TheLoadingIndicator.vue?vue&type=script&lang=ts"
export * from "./TheLoadingIndicator.vue?vue&type=script&lang=ts"
import style0 from "./TheLoadingIndicator.vue?vue&type=style&index=0&id=0b1970b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports